import { useState } from 'react'
import { useAppSelector } from '@/hooks'
import { BgColorsOutlined as _BgColorsOutlined } from '@ant-design/icons'
import { Tooltip, message } from 'antd'

//@ts-ignore
// const eyeDropperInstance = new EyeDropper()

const Fucai = () => {
  // 点击复制颜色值的回调
  const handleCopyColor = function (colorName: string) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(colorName)
    } else {
      const textarea = document.createElement('textarea')
      document.body.appendChild(textarea)
      // 隐藏此输入框
      textarea.style.position = 'fixed'
      textarea.style.top = '10px'
      // 赋值
      textarea.value = colorName
      // 选中
      textarea.select()
      // 复制
      document.execCommand('copy', true)
      // 移除输入框
      document.body.removeChild(textarea)
    }
    message.success('复制成功！' + colorName)
  }
  const [_result, _setResult] = useState<string>('')
  const fucaiData = useAppSelector((state) => state.sixLawsInfo.colorBar)

  // const openEyeDropper = () => {
  //   eyeDropperInstance
  //     .open()
  //     .then((result) => {
  //       console.log(result)
  //       setResult(result.sRGBHex)
  //     })
  //     .catch((e) => {
  //       setResult(e)
  //     })
  // }

  return (
    <div className='fucai-panel'>
      <div className='fucai-title'>
        <h2>随类赋彩</h2>
        <div className='fucai-colorPicker'>
          {/* <BgColorsOutlined onClick={openEyeDropper} className="fucai-colorPicker-button" /> */}
          {/* <Tooltip title={result}>
            <div className="fucai-colorpicker-showBox" style={{ background: result }}></div>
          </Tooltip> */}
        </div>
      </div>

      <div className='fucai-colors'>
        {fucaiData.map((item) => {
          return (
            <Tooltip title={'点击复制：' + item.name} key={item.name}>
              <div className='fucai-eachColor' key={item.name} style={{ width: item.percentage }}>
                <div
                  onClick={() => handleCopyColor(item.color)}
                  className='fucai-eachColor-percentage'
                  style={{
                    backgroundColor: item.color,
                    color: 'white'
                  }}
                >
                  {item.percentage}
                </div>
              </div>
            </Tooltip>
          )
        })}
      </div>
    </div>
  )
}

export default Fucai
